import { render } from "./Calleds.vue?vue&type=template&id=33f8ac9b&scoped=true"
import script from "./Calleds.vue?vue&type=script&lang=js"
export * from "./Calleds.vue?vue&type=script&lang=js"

import "./Calleds.vue?vue&type=style&index=0&id=33f8ac9b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f8ac9b"]])

export default __exports__